(function () {
'use strict';

const root = document.getElementById('wl-art-studio-v3');
if (!root || root.dataset.wlStudioReady === 'true') return;
root.dataset.wlStudioReady = 'true';

window.setTimeout(() => {
  if (WAGLIFE_FOUNDER_TEST_MODE) {
    showToast('Founder test mode active — creation limit bypassed.', 5000);
  }
}, 500);

const WAGLIFE_ART_ENDPOINT = 'https://waglife-art-studio-85238371012.us-central1.run.app';
const WAGLIFE_PRINTFUL_PREVIEW_ENDPOINT = 'https://waglife-printful-preview-85238371012.us-central1.run.app';

const WAGLIFE_PRODUCT_CATALOG = {
  'Framed Canvas': {
    handle: 'custom-ai-dog-portrait-framed-canvas',
    productUrl: '/products/custom-ai-dog-portrait-framed-canvas.js',
    colors: ['Black', 'Brown'],
    sizes: ['8x10', '9x12', '11x14', '12x16', '12x18', '16x20', '18x24', '20x28', '20x30', '24x32', '24x36'],
    skuByColorAndSize: {
      Black: {
        '8x10': '2256989_17627', '9x12': '2256989_17628', '11x14': '2256989_17629',
        '12x16': '2256989_16035', '12x18': '2256989_17630', '16x20': '2256989_16037',
        '18x24': '2256989_16038', '20x28': '2256989_17631', '20x30': '2256989_17633',
        '24x32': '2256989_17632', '24x36': '2256989_16039'
      },
      Brown: {
        '8x10': '2256989_17634', '9x12': '2256989_17635', '11x14': '2256989_17636',
        '12x16': '2256989_16041', '12x18': '2256989_17637', '16x20': '2256989_16043',
        '18x24': '2256989_16044', '20x28': '2256989_17638', '20x30': '2256989_17640',
        '24x32': '2256989_17639', '24x36': '2256989_16045'
      }
    }
  },
  'Phone Case': {
    handle: 'tough-case-for-iphone®',
    productUrl: '/products/tough-case-for-iphone%C2%AE.js',
    models: [
      { label: 'iPhone 11', sku: '6877851_15381' },
      { label: 'iPhone 16', sku: '6877851_20302' },
      { label: 'iPhone 16 Pro Max', sku: '6877851_20305' },
      { label: 'iPhone 17', sku: '6877851_33985' },
      { label: 'iPhone 17 Pro Max', sku: '6877851_33988' }
    ]
  },
  'Clear Tote Bag': {
    handle: 'clear-tote-bag',
    productUrl: '/products/clear-tote-bag.js',
    shopifyVariantId: 46330412826658,
    defaultPriceCents: 4999,
    singleVariant: true,
    placement: 'front',
    safeZone: 'centered-generous',
    fulfillmentReady: false
  },
  'Pickleball Paddle Set': {
    handle: 'pickleball-paddle-set',
    productUrl: '/products/pickleball-paddle-set.js',
    shopifyVariantId: 46330546585634,
    defaultPriceCents: 8999,
    singleVariant: true,
    placement: 'front',
    safeZone: 'centered-tight',
    fulfillmentReady: false
  }
};

const productJsonCache = new Map();
const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
const MAX_NORMALIZED_DIMENSION = 6000;
const JPEG_QUALITY = 0.94;

/*
  The browser crop is the high-quality source sent to the art service.
  The backend must create and persist the full print master requested below.
  Keeping these separate avoids sending an unnecessarily huge base64 payload
  while still guaranteeing true 6000-pixel-class fulfillment files.
*/
const SOURCE_CROP_SPECS = {
  portrait: { width: 2400, height: 3000, ratio: 4 / 5 },
  landscape: { width: 3000, height: 2400, ratio: 5 / 4 }
};

const PRINT_MASTER_SPECS = {
  portrait: { width: 4800, height: 6000, ratio: 4 / 5, label: 'Portrait — Tall & Classic' },
  landscape: { width: 6000, height: 4800, ratio: 5 / 4, label: 'Landscape — Wide & Cinematic' }
};

const ANALYSIS_TIMEOUT_MS = 30000;
const GENERATION_TIMEOUT_MS = 180000;

const INSTALL_ID_KEY='waglife-install-id';
const CREATIONS_REMAINING_KEY='waglife-creations-remaining';
const CREATION_LIMIT_REACHED_KEY='waglife-creation-limit-reached';
const PLUS_ACTIVE_KEY='waglife-plus-active';
const FREE_PREVIEW_LIMIT = 1;
const PLUS_MONTHLY_CREATION_ALLOWANCE = 20;
const GENERATION_GUARD_VERSION = '2026.08.08-v1';

let wagLifePlusActive =
  window.WAGLIFE_PLUS_ACTIVE === true ||
  sessionStorage.getItem(PLUS_ACTIVE_KEY) === 'true';

/*
  Founder test mode:
  Open the studio once with ?waglifeFounder=1 to enable it for this browser session.
  It uses a fresh internal test install ID for each generation so you can reach
  the keepsake preview without changing the production paywall for customers.
*/
const founderQueryEnabled =
  new URLSearchParams(window.location.search).get('waglifeFounder') === '1';

if (founderQueryEnabled) {
  sessionStorage.setItem('waglife-founder-test-mode', '1');
}

const WAGLIFE_FOUNDER_TEST_MODE =
  sessionStorage.getItem('waglife-founder-test-mode') === '1';

function waglifeInstallId(){
  let id=localStorage.getItem(INSTALL_ID_KEY);
  if(!id){
    id=(crypto.randomUUID?crypto.randomUUID():'wl-'+Date.now()+'-'+Math.random().toString(36).slice(2));
    localStorage.setItem(INSTALL_ID_KEY,id);
  }
  return id;
}

function waglifeGenerationInstallId(){
  if (!WAGLIFE_FOUNDER_TEST_MODE) {
    return waglifeInstallId();
  }

  return 'wl-founder-test-' +
    Date.now() + '-' +
    Math.random().toString(36).slice(2);
}

function getStoredCreationsRemaining(){
  const raw = localStorage.getItem(CREATIONS_REMAINING_KEY);
  if (raw === null || raw === '') return null;

  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

function rememberCreationsRemaining(value){
  if (typeof value !== 'number' || !Number.isFinite(value)) return;

  localStorage.setItem(CREATIONS_REMAINING_KEY, String(value));

  if (value <= 0) {
    localStorage.setItem(CREATION_LIMIT_REACHED_KEY, 'true');
  } else {
    localStorage.removeItem(CREATION_LIMIT_REACHED_KEY);
  }
}

function hasKnownCreationLimit(){
  if (WAGLIFE_FOUNDER_TEST_MODE) return false;

  return localStorage.getItem(CREATION_LIMIT_REACHED_KEY) === 'true' ||
    getStoredCreationsRemaining() === 0;
}

function clearCreationLimitState(){
  localStorage.removeItem(CREATION_LIMIT_REACHED_KEY);
  localStorage.removeItem(CREATIONS_REMAINING_KEY);
  state.creationLimitReached = false;
}

function waglifeRequestId(){
  return (crypto.randomUUID?crypto.randomUUID():'req-'+Date.now()+'-'+Math.random().toString(36).slice(2));
}

const state = {
step: 1,
file: null,
imageUrl: '',
generatedUrls: [],
printMasterUrls: [],
artworkDimensions: [],
selectedVariant: 0,
orientation: 'portrait',
story: 'The Way They Look at You',
storyKey: 'the-way-they-look-at-you',
look: 'True to Life',
lookKey: 'true-to-life',
backendFeeling: 'cozy',
intensity: 50,
refine: '',
product: 'Framed Canvas',
selectedProductColor: 'Black',
selectedProductSize: '8x10',
selectedPhoneModel: '',
shopifyVariantId: 0,
shopifyVariantSku: '',
shopifyVariantTitle: '',
shopifyPriceCents: 0,
favorite: false,
reaction: '',
printfulPreviewUrl: '',
printfulProductId: 0,
printfulVariantId: 0,
printfulPlacement: '',
generationInFlight: false,
generationError: '',
creationLimitReached: false,
resumeGenerationAfterPurchase: false,
crop: {
zoom: 1,
x: 0,
y: 0,
naturalWidth: 0,
naturalHeight: 0,
baseScale: 1,
renderedWidth: 0,
renderedHeight: 0
},
croppedFile: null,
croppedPreviewUrl: ''
};

const $ = selector => root.querySelector(selector);
const $$ = selector => Array.from(root.querySelectorAll(selector));

const input = $('#wl3PhotoInput');
const uploadZone = $('#wl3UploadZone');
const uploadEmpty = $('#wl3UploadEmpty');
const uploadPreview = $('#wl3UploadPreview');
const previewImage = $('#wl3PreviewImage');
const analysisImage = $('#wl3AnalysisImage');
const stylePreviewImage = $('#wl3StylePreviewImage');
const generateImage = $('#wl3GenerateImage');
const resultImage = $('#wl3ResultImage');
const productImage = $('#wl3ProductImage');
const analyzeButton = $('#wl3AnalyzeButton');
const memoryText = $('#wl3MemoryText');
const memoryCount = $('#wl3MemoryCount');
const intensity = $('#wl3Intensity');
const toast = $('#wl3Toast');
const saveButton = $('#wl3SaveButton');
const keepsakeButton = $('#wl3KeepsakeButton');
const choosePhotoButton = $('#wl3ChoosePhotoButton');
const changePhotoButton = $('#wl3ChangePhotoButton');
const cropViewport = $('#wl3CropViewport');
const cropZoom = $('#wl3CropZoom');
const autoFitButton = $('#wl3AutoFitButton');
const resetCropButton = $('#wl3ResetCropButton');
const cropHint = $('#wl3CropHint');
const analysisRing = $('.wl3-analysis__rings');
const productOptions = $('#wl3ProductOptions');
const productPrice = $('#wl3ProductPrice');


/* =========================================================
   PRINT ORIENTATION — AUTHORITATIVE COMPOSITION CHOICE
========================================================= */

function currentSourceCropSpec() {
  return SOURCE_CROP_SPECS[state.orientation] || SOURCE_CROP_SPECS.portrait;
}

function currentPrintMasterSpec() {
  return PRINT_MASTER_SPECS[state.orientation] || PRINT_MASTER_SPECS.portrait;
}

function applyOrientationToCropViewport() {
  if (!cropViewport) return;
  const spec = currentPrintMasterSpec();
  cropViewport.style.aspectRatio = spec.width + ' / ' + spec.height;
  cropViewport.dataset.orientation = state.orientation;

  window.requestAnimationFrame(() => {
    if (state.file) {
      resetCrop();
      updateCropMetrics();
      applyCropTransform();
    }
  });
}

function injectOrientationPicker() {
  if ($('#wl3OrientationPicker')) return;

  const host = analyzeButton?.parentElement || uploadPreview || uploadZone;
  if (!host) return;

  const picker = document.createElement('section');
  picker.id = 'wl3OrientationPicker';
  picker.className = 'wl3-orientation';
  picker.setAttribute('aria-label', 'Choose artwork orientation');
  picker.innerHTML = `
    <div class="wl3-orientation__heading">
      <strong>Choose your artwork shape</strong>
      <span>This controls the composition and print sizes from the start.</span>
    </div>
    <div class="wl3-orientation__options" role="radiogroup">
      <button type="button" class="wl3-orientation__option is-selected" data-orientation="portrait" role="radio" aria-checked="true">
        <span class="wl3-orientation__frame wl3-orientation__frame--portrait"></span>
        <span><b>Portrait</b><small>Tall & Classic</small></span>
      </button>
      <button type="button" class="wl3-orientation__option" data-orientation="landscape" role="radio" aria-checked="false">
        <span class="wl3-orientation__frame wl3-orientation__frame--landscape"></span>
        <span><b>Landscape</b><small>Wide & Cinematic</small></span>
      </button>
    </div>`;

  host.insertBefore(picker, analyzeButton || null);

  picker.querySelectorAll('[data-orientation]').forEach(button => {
    button.addEventListener('click', async () => {
      const next = button.dataset.orientation === 'landscape' ? 'landscape' : 'portrait';
      if (next === state.orientation) return;

      state.orientation = next;
      state.croppedFile = null;
      if (state.croppedPreviewUrl) {
        URL.revokeObjectURL(state.croppedPreviewUrl);
        state.croppedPreviewUrl = '';
      }

      picker.querySelectorAll('[data-orientation]').forEach(item => {
        const selected = item.dataset.orientation === state.orientation;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      applyOrientationToCropViewport();
      if (state.file) await initializeCropEditor();
      showToast(currentPrintMasterSpec().label + ' selected.');
    });
  });
}

const orientationStyle = document.createElement('style');
orientationStyle.textContent = `
#wl-art-studio-v3 .wl3-orientation { margin: 20px 0; display: grid; gap: 12px; }
#wl-art-studio-v3 .wl3-orientation__heading { display: grid; gap: 3px; }
#wl-art-studio-v3 .wl3-orientation__heading span { opacity: .72; font-size: 13px; }
#wl-art-studio-v3 .wl3-orientation__options { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 10px; }
#wl-art-studio-v3 .wl3-orientation__option { display: flex; align-items: center; gap: 12px; min-height: 72px; padding: 12px; border: 1px solid rgba(255,255,255,.14); border-radius: 16px; background: rgba(255,255,255,.04); color: inherit; text-align: left; cursor: pointer; }
#wl-art-studio-v3 .wl3-orientation__option.is-selected { border-color: var(--gold); box-shadow: 0 0 0 1px var(--gold), 0 10px 30px rgba(241,196,94,.12); }
#wl-art-studio-v3 .wl3-orientation__option span:last-child { display: grid; gap: 2px; }
#wl-art-studio-v3 .wl3-orientation__option small { opacity: .72; }
#wl-art-studio-v3 .wl3-orientation__frame { display: block; flex: 0 0 auto; border: 2px solid currentColor; border-radius: 3px; box-shadow: inset 0 0 0 4px rgba(241,196,94,.18); }
#wl-art-studio-v3 .wl3-orientation__frame--portrait { width: 30px; height: 38px; }
#wl-art-studio-v3 .wl3-orientation__frame--landscape { width: 42px; height: 34px; }
@media (max-width: 560px) { #wl-art-studio-v3 .wl3-orientation__options { grid-template-columns: 1fr; } }
`;
document.head.appendChild(orientationStyle);
injectOrientationPicker();
applyOrientationToCropViewport();


/* =========================================================
   WAGLIFE LOADING EXPERIENCE
   Circular progress around the dog + hard timeout recovery.
========================================================= */

const loadingStyle = document.createElement('style');
loadingStyle.textContent = `
#wl-art-studio-v3 .wl3-analysis__rings {
  border: 0 !important;
  background: conic-gradient(
    var(--gold) var(--wl-analysis-progress, 0%),
    rgba(241,196,94,.13) 0
  );
  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 8px),
    #000 calc(100% - 7px)
  );
  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 8px),
    #000 calc(100% - 7px)
  );
  animation: none !important;
  filter: drop-shadow(0 0 10px rgba(241,196,94,.18));
  transition: background .24s linear, filter .28s ease;
}
#wl-art-studio-v3 .wl3-analysis__rings::before,
#wl-art-studio-v3 .wl3-analysis__rings::after {
  display: none !important;
}
#wl-art-studio-v3 .wl3-analysis__visual img {
  animation: wl3AnalysisBreathe 2.8s ease-in-out infinite;
}
#wl-art-studio-v3 .wl3-analysis__visual.is-complete .wl3-analysis__rings {
  filter: drop-shadow(0 0 18px rgba(241,196,94,.72));
}
#wl-art-studio-v3 .wl3-analysis__visual.is-failed .wl3-analysis__rings {
  background: conic-gradient(
    #d97b68 100%,
    rgba(217,123,104,.18) 0
  );
  filter: drop-shadow(0 0 12px rgba(217,123,104,.35));
}
#wl-art-studio-v3 #wl3AnalysisBar,
#wl-art-studio-v3 #wl3AnalysisBar:empty,
#wl-art-studio-v3 .wl3-analysis > .wl3-meter {
  display: none !important;
}
@keyframes wl3AnalysisBreathe {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.018); }
}
@media (prefers-reduced-motion: reduce) {
  #wl-art-studio-v3 .wl3-analysis__visual img {
    animation: none !important;
  }
}
`;
document.head.appendChild(loadingStyle);

function setAnalysisProgress(value) {
  const safeValue = Math.max(0, Math.min(100, Number(value) || 0));
  if (analysisRing) {
    analysisRing.style.setProperty('--wl-analysis-progress', safeValue + '%');
  }
}

function createTimeoutError(message) {
  const error = new Error(message);
  error.name = 'TimeoutError';
  return error;
}

function withTimeout(promise, milliseconds, message) {
  let timeoutId = null;

  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = window.setTimeout(() => {
      reject(createTimeoutError(message));
    }, milliseconds);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    if (timeoutId) window.clearTimeout(timeoutId);
  });
}

function fetchWithTimeout(url, options, milliseconds, message) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), milliseconds);

  return fetch(url, {
    ...options,
    signal: controller.signal
  }).catch(error => {
    if (error && error.name === 'AbortError') {
      throw createTimeoutError(message);
    }
    throw error;
  }).finally(() => {
    window.clearTimeout(timeoutId);
  });
}

function showToast(message, duration = 2600) {
toast.textContent = message;
toast.classList.add('is-visible');
window.clearTimeout(showToast.timer);
showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), duration);
}

function setStep(step) {
state.step = step;
$$('[data-panel]').forEach(panel => {
panel.classList.toggle('is-active', Number(panel.dataset.panel) === step);
});
$('#wl3AnalysisPanel').classList.remove('is-active');
$('#wl3AnalysisPanel').hidden = true;
$$('.wl3-progress__step').forEach((item, index) => {
const number = index + 1;
item.classList.toggle('is-active', number === step);
item.classList.toggle('is-complete', number < step);
});
root.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function showAnalysis() {
$$('[data-panel]').forEach(panel => panel.classList.remove('is-active'));
const panel = $('#wl3AnalysisPanel');
panel.hidden = false;
panel.classList.add('is-active');
root.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

async function usePhoto(file) {
if (!file) return;

const fileName = String(file.name || '').toLowerCase();
const looksLikeImage = file.type.startsWith('image/') || /\.(jpe?g|png|webp|heic|heif)$/i.test(fileName);

if (!looksLikeImage) {
showToast('Please choose a photo from your device.');
return;
}

if (file.size > MAX_UPLOAD_BYTES) {
showToast('Please choose a photo smaller than 15 MB.');
return;
}

analyzeButton.disabled = true;
showToast('Preparing your photo…');

try {
const normalizedFile = await normalizePhotoToJpeg(file);

if (state.imageUrl) URL.revokeObjectURL(state.imageUrl);

state.file = normalizedFile;
state.imageUrl = URL.createObjectURL(normalizedFile);
state.generatedUrls = [];
state.printMasterUrls = [];
state.artworkDimensions = [];
state.selectedVariant = 0;
state.croppedFile = null;

[previewImage, analysisImage, stylePreviewImage, generateImage, resultImage, productImage].forEach(img => {
img.src = state.imageUrl;
});

$$('.wl3-variant img').forEach(img => {
img.src = state.imageUrl;
});

uploadEmpty.hidden = true;
uploadPreview.hidden = false;
analyzeButton.disabled = false;
await initializeCropEditor();
showToast('Photo ready.');
} catch (error) {
console.error('WagLife photo preparation failed:', error);
state.file = null;
analyzeButton.disabled = true;
showToast(error instanceof Error ? error.message : 'This photo could not be prepared. Please choose another.', 5200);
}
}

/* =========================================================
   WAGLIFE PHOTO PICKER — IOS SAFE
   Prevent duplicate picker opens and allow reselecting
   the same photo.
========================================================= */

function openPhotoPicker(event) {
if (event) {
event.preventDefault();
event.stopPropagation();
}

/*
Clear the previous selection so choosing the same photo
again still fires the change event on iPhone.
*/
input.value = '';
input.click();
}

choosePhotoButton?.addEventListener('click', openPhotoPicker);
changePhotoButton?.addEventListener('click', openPhotoPicker);

uploadZone?.addEventListener('click', event => {
/*
The dedicated buttons already handle their own taps.
Only let the blank upload area open the picker.
*/
if (
event.target === choosePhotoButton ||
event.target === changePhotoButton ||
event.target.closest('#wl3ChoosePhotoButton') ||
event.target.closest('#wl3ChangePhotoButton')
) {
return;
}

if (!uploadPreview.hidden) return;

if (
event.target === uploadZone ||
uploadEmpty?.contains(event.target)
) {
openPhotoPicker(event);
}
});

input?.addEventListener('change', async event => {
const selectedFile =
event.target.files &&
event.target.files.length
? event.target.files[0]
: null;

if (!selectedFile) {
return;
}

await usePhoto(selectedFile);
});

['dragenter', 'dragover'].forEach(name => {
uploadZone.addEventListener(name, event => {
event.preventDefault();
uploadZone.classList.add('is-dragging');
});
});

['dragleave', 'drop'].forEach(name => {
uploadZone.addEventListener(name, event => {
event.preventDefault();
uploadZone.classList.remove('is-dragging');
});
});

uploadZone.addEventListener('drop', async event => {
await usePhoto(event.dataTransfer.files && event.dataTransfer.files[0]);
});

analyzeButton.addEventListener('click', async () => {
if (!state.file || analyzeButton.disabled) {
showToast('Choose a photo first.');
return;
}

const analysisVisual = $('.wl3-analysis__visual');
const message = $('#wl3AnalysisMessage');
const checks = $$('.wl3-check');

const messages = [
'Getting to know your best friend…',
'Studying their expression and personality…',
'Protecting the little details that make them unmistakably them…',
'Finding the strongest composition for their artwork…',
'Preparing the next step…'
];

let value = 0;
let timer = null;
let slowMessageTimer = null;

analyzeButton.disabled = true;

try {
/*
Capture the crop FIRST while the Step 1 crop viewport is still visible.
Only after this succeeds do we hide Step 1 and show the analysis screen.
*/
await withTimeout(
commitCropPreview(),
ANALYSIS_TIMEOUT_MS,
'WagLife could not finish preparing this photo. Please try again.'
);

showAnalysis();

checks.forEach(item => item.classList.remove('is-done'));
analysisVisual?.classList.remove('is-complete', 'is-failed');
setAnalysisProgress(0);
message.textContent = messages[0];

timer = window.setInterval(() => {
const increase = value < 60 ? 4 : value < 88 ? 2 : 1;
value = Math.min(94, value + increase);
setAnalysisProgress(value);

const messageIndex = Math.min(
messages.length - 1,
Math.floor(value / 22)
);
message.textContent = messages[messageIndex];

checks.forEach((check, checkIndex) => {
if (value >= (checkIndex + 1) * 22) {
check.classList.add('is-done');
}
});
}, 110);

slowMessageTimer = window.setTimeout(() => {
message.textContent = 'This one is taking a little longer, but WagLife is still working.';
}, 10000);

/*
The analysis is an intentional experience, not a backend wait.
Let the ring complete smoothly, then continue.
*/
await wait(3200);

window.clearInterval(timer);
window.clearTimeout(slowMessageTimer);

setAnalysisProgress(100);
checks.forEach(item => item.classList.add('is-done'));
message.textContent = 'We found what makes this photo special.';
analysisVisual?.classList.add('is-complete');

await wait(650);
setStep(2);
} catch (error) {
window.clearInterval(timer);
window.clearTimeout(slowMessageTimer);

analysisVisual?.classList.add('is-failed');
console.error('WagLife photo analysis failed:', error);

showToast(
error instanceof Error
? error.message
: 'WagLife could not finish preparing this photo. Please try again.',
6200
);

setStep(1);
} finally {
analyzeButton.disabled = !state.file;
}
});

function selectedStoryCards() {
return $$('.wl3-style-card[data-story]');
}

function selectStory(card) {
selectedStoryCards().forEach(item => item.classList.remove('is-selected'));
card.classList.add('is-selected');
state.story = card.dataset.story;
state.storyKey = card.dataset.storyKey;
state.backendFeeling = card.dataset.feeling || state.backendFeeling;
$('#wl3PreviewStory').textContent = state.story;
$('#wl3ResultStory').textContent = state.story;
}

selectedStoryCards().forEach(card => {
card.addEventListener('click', () => selectStory(card));
});

$('#wl3SurpriseStory').addEventListener('click', () => {
const choices = selectedStoryCards();
const choice = choices[Math.floor(Math.random() * choices.length)];
selectStory(choice);
showToast('WagLife chose “' + state.story + '.”');
});

function selectLook(card) {
$$('#wl3LookPicker .wl3-look-card').forEach(item => item.classList.remove('is-selected'));
card.classList.add('is-selected');
state.look = card.dataset.look;
state.lookKey = card.dataset.lookKey;
state.backendFeeling = card.dataset.feeling || state.backendFeeling;
$('#wl3PreviewLook').textContent = state.look;
$('#wl3ResultLook').textContent = state.look;
}

$$('#wl3LookPicker .wl3-look-card').forEach(card => {
card.addEventListener('click', () => selectLook(card));
});

$('#wl3SurpriseLook').addEventListener('click', () => {
const choices = $$('#wl3LookPicker .wl3-look-card');
const choice = choices[Math.floor(Math.random() * choices.length)];
selectLook(choice);
intensity.value = Math.floor(Math.random() * 46) + 35;
updateIntensity();
showToast('WagLife chose “' + state.look + '.”');
});

function updateIntensity() {
state.intensity = Number(intensity.value);
$('#wl3IntensityValue').textContent = state.intensity + '%';
let label = 'Balanced transformation';
if (state.intensity < 34) label = 'Subtle and realistic';
if (state.intensity > 66) label = 'Bold and artistic';
$('#wl3PreviewIntensity').textContent = label;
}

intensity.addEventListener('input', updateIntensity);
memoryText.addEventListener('input', () => {
memoryCount.textContent = memoryText.value.length;
});

$$('[data-next]').forEach(button => {
button.addEventListener('click', () => setStep(Number(button.dataset.next)));
});

$$('[data-back]').forEach(button => {
button.addEventListener('click', () => setStep(Number(button.dataset.back)));
});

$$('[data-jump]').forEach(button => {
button.addEventListener('click', () => {
const target = Number(button.dataset.jump);
if (target === 1) {
setStep(1);
return;
}
if (!state.file) {
showToast('Choose a photo first.');
return;
}
if (target <= state.step) setStep(target);
});
});



function waglifeGuardSnapshot() {
  return {
    version: GENERATION_GUARD_VERSION,
    installId: waglifeInstallId(),
    founderTest: WAGLIFE_FOUNDER_TEST_MODE,
    plusActive: wagLifePlusActive,
    remaining: getStoredCreationsRemaining(),
    freePreviewLimit: FREE_PREVIEW_LIMIT,
    plusMonthlyAllowance: PLUS_MONTHLY_CREATION_ALLOWANCE
  };
}

function waglifeTrack(eventName, details) {
  const payload = Object.assign({
    event: eventName,
    source: 'waglife-ai-art-studio',
    occurredAt: new Date().toISOString(),
    guard: waglifeGuardSnapshot()
  }, details || {});

  try {
    window.dispatchEvent(
      new CustomEvent('waglife:generation-guard', { detail: payload })
    );
  } catch (error) {}

  try {
    console.log('[WagLife Generation Guard]', payload);
  } catch (error) {}
}

function waglifeCanGenerateLocally() {
  if (WAGLIFE_FOUNDER_TEST_MODE) return true;
  const remaining = getStoredCreationsRemaining();
  if (remaining === 0) return false;
  return localStorage.getItem(CREATION_LIMIT_REACHED_KEY) !== 'true';
}

function postToNativeHandler(handlerName, payload) {
  try {
    const handlers =
      window.webkit &&
      window.webkit.messageHandlers;

    const handler = handlers && handlers[handlerName];

    if (handler && typeof handler.postMessage === 'function') {
      handler.postMessage(payload);
      return true;
    }
  } catch (error) {
    console.warn('WagLife native paywall bridge failed:', error);
  }

  return false;
}

function requestWagLifePaywall() {
  state.resumeGenerationAfterPurchase = true;

  const payload = {
    action: 'openPaywall',
    source: 'waglife-ai-art-studio',
    reason: 'creation-limit-reached'
  };

  const sent =
    postToNativeHandler('openPaywall', payload) ||
    postToNativeHandler('paywall', payload) ||
    postToNativeHandler('subscription', payload) ||
    postToNativeHandler('iap', payload) ||
    postToNativeHandler('storeKit', payload) ||
    postToNativeHandler('nativeApp', payload);

  try {
    document.dispatchEvent(
      new CustomEvent('waglife:open-paywall', { detail: payload })
    );

    window.dispatchEvent(
      new CustomEvent('waglife:open-paywall', { detail: payload })
    );
  } catch (error) {
    console.warn('WagLife paywall event failed:', error);
  }

  if (!sent) {
    showToast('Choose WagLife Plus to keep creating.', 5200);
  }

  return sent;
}

function removeCreationLimitUpgrade() {
  const existing = $('#wl3CreationLimitUpgrade');
  if (existing) existing.remove();
}

function showCreationLimitUpgrade(messageText) {
  const panel = $('[data-panel="4"]');
  const bar = $('#wl3GenerateBar');
  const percent = $('#wl3GeneratePercent');
  const label = $('#wl3GenerateLabel');
  const message = $('#wl3GenerateMessage');
  const stages = $$('.wl3-stage');

  if (!panel) return;

  state.creationLimitReached = true;
  state.generationError = '';
  localStorage.setItem(CREATION_LIMIT_REACHED_KEY, 'true');
  localStorage.setItem(CREATIONS_REMAINING_KEY, '0');

  removeGenerationRetryButton();
  removeCreationLimitUpgrade();

  if (bar) bar.style.width = '0%';
  if (percent) percent.textContent = '';
  if (label) label.textContent = 'Your free creations are complete';
  if (message) {
    message.textContent =
      messageText ||
      "You've used your free WagLife creation. Unlock WagLife Plus to keep bringing their story to life.";
  }

  stages.forEach(item => {
    item.classList.remove('is-active', 'is-done');
    item.style.display = 'none';
  });

  const panelCopy = panel.querySelectorAll('p');
  panelCopy.forEach(item => {
    if (
      /keep this page open/i.test(item.textContent || '') ||
      /while WagLife creates/i.test(item.textContent || '')
    ) {
      item.style.display = 'none';
    }
  });

  const heading = panel.querySelector('h1, h2, .wl3-title, .wl3-generate__title');
  if (heading) {
    heading.textContent = 'Your free creations are complete';
  }

  const upgrade = document.createElement('div');
  upgrade.id = 'wl3CreationLimitUpgrade';
  upgrade.style.marginTop = '22px';
  upgrade.style.display = 'grid';
  upgrade.style.gap = '12px';

  const primary = document.createElement('button');
  primary.type = 'button';
  primary.className = 'wl3-button wl3-button--primary';
  primary.style.width = '100%';
  primary.textContent = 'Unlock WagLife Plus';

  primary.addEventListener('click', event => {
    event.preventDefault();
    requestWagLifePaywall();
  });

  const restore = document.createElement('button');
  restore.type = 'button';
  restore.className = 'wl3-button wl3-button--secondary';
  restore.style.width = '100%';
  restore.textContent = 'Restore Purchases';

  restore.addEventListener('click', event => {
    event.preventDefault();

    const payload = {
      action: 'restore',
      source: 'waglife-ai-art-studio'
    };

    const sent =
      postToNativeHandler('restorePurchases', payload) ||
      postToNativeHandler('subscription', payload) ||
      postToNativeHandler('iap', payload) ||
      postToNativeHandler('storeKit', payload) ||
      postToNativeHandler('nativeApp', payload);

    try {
      document.dispatchEvent(
        new CustomEvent('waglife:restore-purchases', { detail: payload })
      );
    } catch (error) {}

    if (!sent) {
      showToast('Restore Purchases is available inside the WagLife app.', 5200);
    }
  });

  upgrade.appendChild(primary);
  upgrade.appendChild(restore);

  if (WAGLIFE_FOUNDER_TEST_MODE) {
    const founderNote = document.createElement('p');
    founderNote.textContent =
      'Founder test mode is active. Refresh and generate again to continue testing.';
    founderNote.style.margin = '4px 0 0';
    founderNote.style.textAlign = 'center';
    founderNote.style.opacity = '.7';
    founderNote.style.fontSize = '12px';
    upgrade.appendChild(founderNote);
  }

  panel.appendChild(upgrade);
}

$('#wl3GenerateButton').addEventListener('click', async () => {
if (state.generationInFlight) return;

state.generationError = '';

if (hasKnownCreationLimit() || !waglifeCanGenerateLocally()) {
  waglifeTrack('generation_blocked', { reason: 'creation-limit-reached' });
  setStep(4);
  showCreationLimitUpgrade();
  return;
}

waglifeTrack('generation_started', {
  orientation: state.orientation,
  story: state.storyKey,
  style: state.lookKey,
  purpose: 'preview'
});

setStep(4);
await runGeneration();
});

function removeGenerationRetryButton() {
const retryButton = $('#wl3GenerationRetryButton');
if (retryButton) retryButton.remove();
}

function showGenerationRetry(errorMessage) {
const panel = $('[data-panel="4"]');
if (!panel) return;

removeGenerationRetryButton();

const retryButton = document.createElement('button');
retryButton.type = 'button';
retryButton.id = 'wl3GenerationRetryButton';
retryButton.className = 'wl3-button wl3-button--primary';
retryButton.textContent = 'Try Creating Again';
retryButton.style.width = '100%';
retryButton.style.marginTop = '18px';

retryButton.addEventListener('click', async () => {
if (state.generationInFlight) return;
state.generationError = '';
removeGenerationRetryButton();
removeCreationLimitUpgrade();
await runGeneration();
});

panel.appendChild(retryButton);

const message = $('#wl3GenerateMessage');
if (message) {
message.textContent = errorMessage || 'WagLife could not finish this artwork. Your choices are still saved.';
}
}

async function runGeneration() {
const bar = $('#wl3GenerateBar');
const percent = $('#wl3GeneratePercent');
const label = $('#wl3GenerateLabel');
const message = $('#wl3GenerateMessage');
const stages = $$('.wl3-stage');
const generateButton = $('#wl3GenerateButton');

if (state.generationInFlight) return;

state.generationInFlight = true;
state.generationError = '';
state.creationLimitReached = false;
state.step = 4;
removeGenerationRetryButton();
removeCreationLimitUpgrade();

if (!state.file) {
state.generationInFlight = false;
showToast('Choose a photo first.');
setStep(1);
return;
}

generateButton.disabled = true;
state.selectedVariant = 0;
state.generatedUrls = [];
state.printMasterUrls = [];
state.artworkDimensions = [];
state.printfulPreviewUrl = '';
state.printfulProductId = 0;
state.printfulVariantId = 0;
state.printfulPlacement = '';

bar.style.width = '0%';
percent.textContent = '0%';
label.textContent = 'Preparing your photo';
message.textContent = 'Building the composition around your dog.';
stages.forEach(item => {
item.style.display = '';
item.classList.remove('is-active', 'is-done');
});
stages[0].classList.add('is-active');

const panel = $('[data-panel="4"]');
if (panel) {
  panel.querySelectorAll('p').forEach(item => {
    if (
      /keep this page open/i.test(item.textContent || '') ||
      /while WagLife creates/i.test(item.textContent || '')
    ) {
      item.style.display = '';
    }
  });
}

let visualProgress = 0;
let generationSlowTimer = window.setTimeout(() => {
message.textContent = 'This one is taking a little longer, but WagLife is still creating.';
}, 10000);

const progressTimer = window.setInterval(() => {
if (visualProgress >= 92) return;
const increase = visualProgress < 35 ? 3 : visualProgress < 70 ? 2 : 1;
visualProgress = Math.min(92, visualProgress + increase);
updateGenerationProgress(visualProgress, bar, percent, label, message, stages);
}, 650);

try {
const croppedFile = state.croppedFile || await exportCroppedPhoto();
const imageBase64 = await fileToDataUrl(croppedFile);
const memory = memoryText.value.trim();

const response = await fetchWithTimeout(
WAGLIFE_ART_ENDPOINT,
{
method: 'POST',
headers: {
'Content-Type': 'application/json',
'X-WagLife-Request-Id': waglifeRequestId()
},
body: (() => {
const requestId=waglifeRequestId();
return JSON.stringify({
requestId,
installId: waglifeGenerationInstallId(),
plusActive: wagLifePlusActive,
imageBase64,
imageType: 'image/jpeg',
goal: 'wall-art',
feeling: state.backendFeeling,
intensity: state.intensity,
memory,
refine: state.refine || '',
story: state.storyKey,
storyName: state.story,
style: state.lookKey,
styleName: state.look,
orientation: state.orientation,
output: {
  purpose: 'commerce-preview',
  width: state.orientation === 'landscape' ? 1536 : 1229,
  height: state.orientation === 'landscape' ? 1229 : 1536,
  aspectRatio: state.orientation === 'landscape' ? '5:4' : '4:5',
  colorSpace: 'sRGB',
  format: 'jpeg',
  quality: 88,
  printMasterDeferred: true,
  requestedPrintMaster: {
    width: currentPrintMasterSpec().width,
    height: currentPrintMasterSpec().height
  }
}
});
})()
},
GENERATION_TIMEOUT_MS,
'WagLife took too long to create this artwork. Please try again.'
);

const responseText = await response.text();
let data = null;

try {
data = JSON.parse(responseText);
} catch (error) {
throw new Error('WagLife received an unreadable response from the art service.');
}

if(data && data.code==='CREATION_LIMIT_REACHED'){
const limitError = new Error(
  data.error ||
  "You've used your free WagLife creation."
);
limitError.code = 'CREATION_LIMIT_REACHED';
throw limitError;
}
if (!response.ok || !data || !data.success) {
throw new Error((data && data.error) || 'The artwork could not be generated.');
}

if(typeof data.remaining==='number'){
rememberCreationsRemaining(data.remaining);
waglifeTrack('generation_allowance_updated', { remaining: data.remaining });
console.log('WagLife creations remaining:',data.remaining);
}

if (!Array.isArray(data.images) || !data.images.length) {
throw new Error('The art service returned no artwork.');
}

const normalizedArtwork = data.images.map(item => {
  if (typeof item === 'string') {
    return { previewUrl: item, printMasterUrl: '', width: 0, height: 0 };
  }

  if (item && typeof item === 'object') {
    return {
      previewUrl: String(item.previewUrl || item.url || item.imageUrl || ''),
      printMasterUrl: String(item.printMasterUrl || item.masterUrl || item.fullResolutionUrl || ''),
      width: Number(item.width || item.printWidth || 0),
      height: Number(item.height || item.printHeight || 0)
    };
  }

  return null;
}).filter(item => item && item.previewUrl);

if (!normalizedArtwork.length) {
  throw new Error('The art service returned no usable artwork.');
}

while (normalizedArtwork.length < 4) {
  normalizedArtwork.push({ ...normalizedArtwork[normalizedArtwork.length % normalizedArtwork.length] });
}

const selectedArtwork = normalizedArtwork.slice(0, 4);
state.generatedUrls = selectedArtwork.map(item => item.previewUrl);
state.printMasterUrls = selectedArtwork.map(item => item.printMasterUrl);
state.artworkDimensions = selectedArtwork.map(item => ({ width: item.width, height: item.height }));

/*
  A production backend should return dimensions with each master. When it does,
  reject anything below the selected print specification before enabling keepsakes.
*/
const required = currentPrintMasterSpec();
const hasPrintMasters = state.printMasterUrls.some(Boolean);
const undersized = hasPrintMasters && state.artworkDimensions.some(size =>
  size.width > 0 && size.height > 0 &&
  (size.width < required.width || size.height < required.height)
);

if (undersized) {
  throw new Error(
    'The art service returned an image below WagLife print quality. Please create it again.'
  );
}

window.clearInterval(progressTimer);
window.clearTimeout(generationSlowTimer);
updateGenerationProgress(100, bar, percent, label, message, stages);
updateResults();
await wait(450);
state.generationError = '';
removeGenerationRetryButton();
setStep(5);
waglifeTrack('generation_completed', {
  returnedImages: state.generatedUrls.length,
  remaining: getStoredCreationsRemaining(),
  orientation: state.orientation,
  story: state.storyKey,
  style: state.lookKey
});
showToast('Your WagLife artwork is ready.');
} catch (error) {
window.clearInterval(progressTimer);
window.clearTimeout(generationSlowTimer);
console.error('WagLife artwork request failed:', error);

let errorMessage = error instanceof Error
? error.message
: 'Artwork generation failed. Please try again.';

if (
  /load failed|failed to fetch|network request failed/i.test(errorMessage)
) {
  errorMessage =
    'WagLife could not reach the art service. Please check your connection and try again.';
}

state.step = 4;

if (error && error.code === 'CREATION_LIMIT_REACHED') {
  state.generationError = '';
  showToast(
    "You've used your free creations. Unlock WagLife Plus or Art Credits to keep creating.",
    7000
  );
  showCreationLimitUpgrade(errorMessage);
} else {
  state.generationError = errorMessage;
  showToast(errorMessage, 5600);
  showGenerationRetry(errorMessage);
}
} finally {
window.clearInterval(progressTimer);
window.clearTimeout(generationSlowTimer);
state.generationInFlight = false;
generateButton.disabled = false;
}
}

function updateGenerationProgress(value, bar, percent, label, message, stages) {
const safeValue = Math.max(0, Math.min(100, value));
bar.style.width = safeValue + '%';
percent.textContent = safeValue + '%';

let stageNumber = 0;
if (safeValue >= 28) stageNumber = 1;
if (safeValue >= 56) stageNumber = 2;
if (safeValue >= 82) stageNumber = 3;

const stageCopy = [
{ label: 'Preparing your photo', message: 'Building the composition around your dog.' },
{ label: 'Preserving their identity', message: 'Keeping the eyes, markings, expression, and personality that make them unique.' },
{ label: 'Creating four versions', message: 'Exploring four distinct ways to tell “' + state.story + '.”' },
{ label: safeValue >= 100 ? 'Artwork complete' : 'Adding finishing touches', message: safeValue >= 100 ? 'Your WagLife artwork is ready.' : 'Refining color, light, texture, anatomy, and detail.' }
];

label.textContent = stageCopy[stageNumber].label;
message.textContent = stageCopy[stageNumber].message;

stages.forEach((item, index) => {
item.classList.toggle('is-active', index === stageNumber && safeValue < 100);
item.classList.toggle('is-done', index < stageNumber || safeValue >= 100);
});
}

async function normalizePhotoToJpeg(file) {
const sourceUrl = URL.createObjectURL(file);

try {
const image = await loadImage(sourceUrl);
const sourceWidth = image.naturalWidth || image.width;
const sourceHeight = image.naturalHeight || image.height;

if (!sourceWidth || !sourceHeight) {
throw new Error('The selected photo has invalid dimensions.');
}

const scale = Math.min(1, MAX_NORMALIZED_DIMENSION / Math.max(sourceWidth, sourceHeight));
const width = Math.max(1, Math.round(sourceWidth * scale));
const height = Math.max(1, Math.round(sourceHeight * scale));
const canvas = document.createElement('canvas');
canvas.width = width;
canvas.height = height;

const context = canvas.getContext('2d', { alpha: false, willReadFrequently: false });

if (!context) throw new Error('WagLife could not prepare this photo.');

context.fillStyle = '#ffffff';
context.fillRect(0, 0, width, height);
context.imageSmoothingEnabled = true;
context.imageSmoothingQuality = 'high';
context.drawImage(image, 0, 0, width, height);

const jpegBlob = await canvasToBlob(canvas, 'image/jpeg', JPEG_QUALITY);

if (!jpegBlob || !jpegBlob.size) throw new Error('The selected photo could not be converted.');
if (jpegBlob.size > MAX_UPLOAD_BYTES) throw new Error('This photo is still too large after preparation.');

return new File([jpegBlob], 'waglife-upload.jpg', { type: 'image/jpeg', lastModified: Date.now() });
} catch (error) {
console.error('WagLife normalization error:', error);
throw new Error('This photo could not be prepared. Try a different photo or a screenshot.');
} finally {
URL.revokeObjectURL(sourceUrl);
}
}


async function initializeCropEditor() {
if (!cropViewport || !previewImage) return;

await waitForImage(previewImage);

state.crop.naturalWidth = previewImage.naturalWidth || 1;
state.crop.naturalHeight = previewImage.naturalHeight || 1;
state.crop.zoom = 1;
state.crop.x = 0;
state.crop.y = 0;

if (cropZoom) cropZoom.value = '100';

updateCropMetrics();
applyCropTransform();

window.requestAnimationFrame(() => {
updateCropMetrics();
applyCropTransform();
});
}

function updateCropMetrics() {
if (!cropViewport || !state.crop.naturalWidth || !state.crop.naturalHeight) return;

const bounds = cropViewport.getBoundingClientRect();
if (!bounds.width || !bounds.height) return;

state.crop.baseScale = Math.max(
bounds.width / state.crop.naturalWidth,
bounds.height / state.crop.naturalHeight
);

const scale = state.crop.baseScale * state.crop.zoom;
state.crop.renderedWidth = state.crop.naturalWidth * scale;
state.crop.renderedHeight = state.crop.naturalHeight * scale;

clampCropOffset(bounds.width, bounds.height);
}

function clampCropOffset(frameWidth, frameHeight) {
const maxX = Math.max(0, (state.crop.renderedWidth - frameWidth) / 2);
const maxY = Math.max(0, (state.crop.renderedHeight - frameHeight) / 2);

state.crop.x = Math.max(-maxX, Math.min(maxX, state.crop.x));
state.crop.y = Math.max(-maxY, Math.min(maxY, state.crop.y));
}

function applyCropTransform() {
if (!previewImage || !cropViewport) return;

const bounds = cropViewport.getBoundingClientRect();
if (!bounds.width || !bounds.height) return;

updateCropMetrics();

previewImage.style.width = state.crop.renderedWidth + 'px';
previewImage.style.height = state.crop.renderedHeight + 'px';
previewImage.style.transform =
'translate(-50%, -50%) translate(' + state.crop.x + 'px, ' + state.crop.y + 'px)';
}

function setCropZoom(nextZoom, anchorX = 0, anchorY = 0) {
const previousZoom = state.crop.zoom;
const safeZoom = Math.max(1, Math.min(3, nextZoom));

if (safeZoom === previousZoom) return;

const ratio = safeZoom / previousZoom;
state.crop.x = anchorX + (state.crop.x - anchorX) * ratio;
state.crop.y = anchorY + (state.crop.y - anchorY) * ratio;
state.crop.zoom = safeZoom;

if (cropZoom) cropZoom.value = String(Math.round(safeZoom * 100));

applyCropTransform();
hideCropHint();
}

function resetCrop() {
state.crop.zoom = 1;
state.crop.x = 0;
state.crop.y = 0;
if (cropZoom) cropZoom.value = '100';
applyCropTransform();
}

function hideCropHint() {
cropHint?.classList.add('is-hidden');
}

cropZoom?.addEventListener('input', () => {
setCropZoom(Number(cropZoom.value) / 100);
});

autoFitButton?.addEventListener('click', () => {
resetCrop();
showToast('Photo centered and fitted.');
});

resetCropButton?.addEventListener('click', () => {
resetCrop();
cropHint?.classList.remove('is-hidden');
showToast('Photo position reset.');
});

const activePointers = new Map();
let dragStart = null;
let pinchStart = null;

cropViewport?.addEventListener('pointerdown', event => {
event.preventDefault();
cropViewport.setPointerCapture(event.pointerId);
activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
cropViewport.classList.add('is-dragging');
hideCropHint();

if (activePointers.size === 1) {
dragStart = {
pointerX: event.clientX,
pointerY: event.clientY,
cropX: state.crop.x,
cropY: state.crop.y
};
}

if (activePointers.size === 2) {
const points = Array.from(activePointers.values());
pinchStart = {
distance: Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y),
zoom: state.crop.zoom
};
}
});

cropViewport?.addEventListener('pointermove', event => {
if (!activePointers.has(event.pointerId)) return;

activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

if (activePointers.size === 2 && pinchStart) {
const points = Array.from(activePointers.values());
const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
setCropZoom(pinchStart.zoom * (distance / Math.max(1, pinchStart.distance)));
return;
}

if (activePointers.size === 1 && dragStart) {
state.crop.x = dragStart.cropX + (event.clientX - dragStart.pointerX);
state.crop.y = dragStart.cropY + (event.clientY - dragStart.pointerY);
applyCropTransform();
}
});

function endCropPointer(event) {
activePointers.delete(event.pointerId);

if (activePointers.size < 2) pinchStart = null;
if (activePointers.size === 0) {
dragStart = null;
cropViewport?.classList.remove('is-dragging');
}
}

cropViewport?.addEventListener('pointerup', endCropPointer);
cropViewport?.addEventListener('pointercancel', endCropPointer);

cropViewport?.addEventListener('wheel', event => {
event.preventDefault();
const bounds = cropViewport.getBoundingClientRect();
const anchorX = event.clientX - bounds.left - bounds.width / 2;
const anchorY = event.clientY - bounds.top - bounds.height / 2;
setCropZoom(state.crop.zoom + (event.deltaY < 0 ? 0.08 : -0.08), anchorX, anchorY);
}, { passive: false });

window.addEventListener('resize', () => {
if (!uploadPreview.hidden) applyCropTransform();
});

async function exportCroppedPhoto() {
if (!previewImage || !cropViewport || !state.file) {
throw new Error('The photo crop could not be prepared.');
}

await waitForImage(previewImage);

const frame = cropViewport.getBoundingClientRect();
if (!frame.width || !frame.height) {
throw new Error('The photo crop is not visible.');
}

updateCropMetrics();

const output = document.createElement('canvas');
const cropSpec = currentSourceCropSpec();
output.width = cropSpec.width;
output.height = cropSpec.height;

const context = output.getContext('2d', { alpha: false });
if (!context) throw new Error('WagLife could not prepare the cropped photo.');

context.fillStyle = '#ffffff';
context.fillRect(0, 0, output.width, output.height);

const outputScale = output.width / frame.width;
const drawWidth = state.crop.renderedWidth * outputScale;
const drawHeight = state.crop.renderedHeight * outputScale;
const drawX = output.width / 2 + state.crop.x * outputScale - drawWidth / 2;
const drawY = output.height / 2 + state.crop.y * outputScale - drawHeight / 2;

context.imageSmoothingEnabled = true;
context.imageSmoothingQuality = 'high';
context.drawImage(previewImage, drawX, drawY, drawWidth, drawHeight);

const blob = await canvasToBlob(output, 'image/jpeg', JPEG_QUALITY);
return new File([blob], 'waglife-composed-photo.jpg', {
type: 'image/jpeg',
lastModified: Date.now()
});
}

async function commitCropPreview() {
const croppedFile = await exportCroppedPhoto();

state.croppedFile = croppedFile;

if (state.croppedPreviewUrl) URL.revokeObjectURL(state.croppedPreviewUrl);
state.croppedPreviewUrl = URL.createObjectURL(croppedFile);

[analysisImage, stylePreviewImage, generateImage, resultImage, productImage].forEach(image => {
image.src = state.croppedPreviewUrl;
});
}

function waitForImage(image) {
if (image.complete && image.naturalWidth) return Promise.resolve();

return new Promise((resolve, reject) => {
const timeout = window.setTimeout(() => reject(new Error('The photo took too long to prepare.')), 20000);
image.addEventListener('load', () => {
window.clearTimeout(timeout);
resolve();
}, { once: true });
image.addEventListener('error', () => {
window.clearTimeout(timeout);
reject(new Error('The photo could not be prepared.'));
}, { once: true });
});
}

function loadImage(url) {
return new Promise((resolve, reject) => {
const image = new Image();
let settled = false;

const timeout = window.setTimeout(() => {
if (settled) return;
settled = true;
image.src = '';
reject(new Error('The selected photo took too long to open.'));
}, 20000);

image.onload = () => {
if (settled) return;
settled = true;
window.clearTimeout(timeout);
resolve(image);
};

image.onerror = () => {
if (settled) return;
settled = true;
window.clearTimeout(timeout);
reject(new Error('The selected photo format could not be opened.'));
};

image.src = url;
});
}

function canvasToBlob(canvas, type, quality) {
return new Promise((resolve, reject) => {
canvas.toBlob(blob => {
if (!blob) {
reject(new Error('The selected photo could not be converted.'));
return;
}
resolve(blob);
}, type, quality);
});
}

function fileToDataUrl(file) {
return new Promise((resolve, reject) => {
const reader = new FileReader();
reader.onload = () => resolve(String(reader.result || ''));
reader.onerror = () => reject(new Error('The selected photo could not be read.'));
reader.readAsDataURL(file);
});
}

function wait(milliseconds) {
return new Promise(resolve => window.setTimeout(resolve, milliseconds));
}

function updateResults() {
const selectedUrl = state.generatedUrls[state.selectedVariant] || state.imageUrl;
resultImage.src = selectedUrl;
productImage.src = selectedUrl;
state.printfulPreviewUrl = '';
state.printfulProductId = 0;
state.printfulVariantId = 0;
state.printfulPlacement = '';
state.shopifyVariantId = 0;
state.shopifyVariantSku = '';
state.shopifyVariantTitle = '';
state.shopifyPriceCents = 0;

if (keepsakeButton) setKeepsakeButtonState(false);

$$('.wl3-variant img').forEach((img, index) => {
img.src = state.generatedUrls[index] || state.imageUrl;
});

$('#wl3ResultLook').textContent = state.look;
$('#wl3ResultStory').textContent = state.story;
const customMemory = memoryText.value.trim();
$('#wl3StoryText').textContent = customMemory || buildDefaultStory();
}

function buildDefaultStory() {
const storiesByKey = {
'the-way-they-look-at-you': 'Some dogs have a way of looking at you that says everything words never could.',
'their-favorite-place': 'Their favorite place was never just a location. It was wherever the best memories happened together.',
'best-day-ever': 'The best days were the loud, muddy, joyful ones—the days they wished could last forever.',
'the-adventure-we-remember': 'The destination mattered less than the fact that your best friend was right there beside you.',
'a-life-well-loved': 'A life well loved leaves paw prints in every room, every routine, and every chapter worth remembering.',
'everyday-hero': 'No cape required. They were already the hero of every homecoming, hard day, and ordinary moment.',
'household-royalty': 'Every home has a ruler. This one just happened to have four paws and excellent taste in furniture.',
'comic-story-adventure': 'Every backyard, treat bag, and open door became the beginning of another great adventure.',
'magical-wonder': 'The world felt a little brighter, warmer, and more magical whenever they were near.'
};

return storiesByKey[state.storyKey] || 'Some dogs become part of the family. The special ones become part of every good memory.';
}

$$('.wl3-variant').forEach(button => {
button.addEventListener('click', () => {
state.selectedVariant = Number(button.dataset.variant);
$$('.wl3-variant').forEach(item => item.classList.remove('is-selected'));
button.classList.add('is-selected');
updateResults();
});
});

$('#wl3FavoriteButton').addEventListener('click', event => {
state.favorite = !state.favorite;
event.currentTarget.classList.toggle('is-favorite', state.favorite);
event.currentTarget.textContent = state.favorite ? '♥' : '♡';
showToast(state.favorite ? 'Saved to your favorites.' : 'Removed from favorites.');
});

$$('#wl3ReactionPicker button').forEach(button => {
button.addEventListener('click', () => {
$$('#wl3ReactionPicker button').forEach(item => item.classList.remove('is-selected'));
button.classList.add('is-selected');
state.reaction = button.dataset.reaction;

if (state.reaction === 'thats-them') showToast('That makes us happy. ♥');
if (state.reaction === 'almost') showToast('Got it. Try a refinement or another version.');
if (state.reaction === 'new-direction') {
showToast('Let’s explore another direction.');
setStep(2);
}
});
});

$$('#wl3RefineChips button').forEach(button => {
button.addEventListener('click', async () => {
$$('#wl3RefineChips button').forEach(item => item.classList.remove('is-selected'));
button.classList.add('is-selected');
state.refine = button.dataset.refine;
showToast('Creating a refined version…');
setStep(4);
await runGeneration();
});
});


function ensureNewKeepsakeTabs() {
  const tabs = $('#wl3ProductTabs');
  if (!tabs) return;

  [
    { name: 'Clear Tote Bag', label: 'Clear Tote' },
    { name: 'Pickleball Paddle Set', label: 'Pickleball Set' }
  ].forEach(item => {
    if (tabs.querySelector('[data-product="' + item.name + '"]')) return;

    const existing = tabs.querySelector('button');
    const button = existing
      ? existing.cloneNode(false)
      : document.createElement('button');

    button.type = 'button';
    button.classList.remove('is-selected');
    button.dataset.product = item.name;
    button.textContent = item.label;
    tabs.appendChild(button);
  });
}

function formatMoney(cents) {
  const value = Number(cents || 0) / 100;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
}

function displayCanvasSize(sizeKey) {
  const parts = String(sizeKey || '').split('x');
  if (parts.length !== 2) return sizeKey;

  const width = state.orientation === 'landscape' ? parts[1] : parts[0];
  const height = state.orientation === 'landscape' ? parts[0] : parts[1];
  return width + '×' + height + ' in';
}

function printfulVariantIdFromSku(sku) {
  const parts = String(sku || '').split('_');
  const value = Number(parts[parts.length - 1]);
  return Number.isInteger(value) && value > 0 ? value : 0;
}

async function loadShopifyProduct(productName) {
  const config = WAGLIFE_PRODUCT_CATALOG[productName];
  if (!config) throw new Error('This keepsake is not connected yet.');

  if (productJsonCache.has(productName)) {
    return productJsonCache.get(productName);
  }

  const request = fetch(config.productUrl, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  }).then(async response => {
    if (!response.ok) {
      throw new Error('WagLife could not load this product from Shopify.');
    }
    return response.json();
  }).catch(error => {
    productJsonCache.delete(productName);
    throw error;
  });

  productJsonCache.set(productName, request);
  return request;
}

function selectedProductSku() {
  const config = WAGLIFE_PRODUCT_CATALOG[state.product];
  if (!config) return '';

  if (state.product === 'Framed Canvas') {
    return config.skuByColorAndSize?.[state.selectedProductColor]?.[state.selectedProductSize] || '';
  }

  if (state.product === 'Phone Case') {
    const model = config.models.find(item => item.label === state.selectedPhoneModel);
    return model ? model.sku : '';
  }

  if (config.singleVariant) {
    return String(config.sku || '');
  }

  return '';
}

function resetCommerceSelection() {
  state.printfulPreviewUrl = '';
  state.printfulProductId = 0;
  state.printfulVariantId = 0;
  state.printfulPlacement = '';
  state.shopifyVariantId = 0;
  state.shopifyVariantSku = '';
  state.shopifyVariantTitle = '';
  state.shopifyPriceCents = 0;

  if (productPrice) productPrice.textContent = '';
  const selectedArtworkUrl = state.generatedUrls[state.selectedVariant] || state.imageUrl;
  if (selectedArtworkUrl) productImage.src = selectedArtworkUrl;
  setKeepsakeButtonState(false);
}

function renderProductOptions() {
  if (!productOptions) return;

  if (state.product === 'Framed Canvas') {
    const config = WAGLIFE_PRODUCT_CATALOG['Framed Canvas'];
    const sizeOptions = config.sizes.map(size =>
      '<option value="' + size + '"' + (size === state.selectedProductSize ? ' selected' : '') + '>' +
      displayCanvasSize(size) + '</option>'
    ).join('');

    const colorOptions = config.colors.map(color =>
      '<option value="' + color + '"' + (color === state.selectedProductColor ? ' selected' : '') + '>' +
      color + '</option>'
    ).join('');

    productOptions.innerHTML =
      '<label><span>Frame color</span><select id="wl3FrameColor">' + colorOptions + '</select></label>' +
      '<label><span>Finished size</span><select id="wl3CanvasSize">' + sizeOptions + '</select></label>' +
      '<small>Artwork orientation stays ' + (state.orientation === 'landscape' ? 'landscape' : 'portrait') + ' from creation through fulfillment.</small>';

    $('#wl3FrameColor')?.addEventListener('change', event => {
      state.selectedProductColor = event.target.value;
      resetCommerceSelection();
      resolveSelectedShopifyVariant().catch(console.error);
    });

    $('#wl3CanvasSize')?.addEventListener('change', event => {
      state.selectedProductSize = event.target.value;
      resetCommerceSelection();
      resolveSelectedShopifyVariant().catch(console.error);
    });
  } else if (state.product === 'Phone Case') {
    const config = WAGLIFE_PRODUCT_CATALOG['Phone Case'];
    const modelOptions = config.models.map(model =>
      '<option value="' + model.label + '"' + (model.label === state.selectedPhoneModel ? ' selected' : '') + '>' +
      model.label + '</option>'
    ).join('');

    productOptions.innerHTML =
      '<label><span>Choose your phone</span><select id="wl3PhoneModel">' +
      '<option value="">Select iPhone model</option>' + modelOptions +
      '</select></label>' +
      '<small>Choose the exact phone model before previewing or ordering.</small>';

    $('#wl3PhoneModel')?.addEventListener('change', event => {
      state.selectedPhoneModel = event.target.value;
      resetCommerceSelection();
      resolveSelectedShopifyVariant().catch(console.error);
    });
  } else {
    const config = WAGLIFE_PRODUCT_CATALOG[state.product];

    if (config && config.singleVariant) {
      const safeCopy = state.product === 'Pickleball Paddle Set'
        ? 'One set · Wood · 7.5 × 15.5 in · artwork uses a tighter face-safe print zone.'
        : 'One size · front placement · artwork stays centered with generous safe margins.';

      productOptions.innerHTML =
        '<small>' + safeCopy + '</small>';
    } else {
      productOptions.innerHTML = '<small>This keepsake will be connected soon.</small>';
    }
  }
}

async function resolveSelectedShopifyVariant() {
  const config = WAGLIFE_PRODUCT_CATALOG[state.product];
  if (!config) {
    state.shopifyVariantId = 0;
    if (productPrice) productPrice.textContent = '';
    setKeepsakeButtonState(false);
    return null;
  }

  const product = await loadShopifyProduct(state.product);
  const variants = Array.isArray(product?.variants) ? product.variants : [];

  let variant = null;

  if (config.singleVariant && config.shopifyVariantId) {
    variant = variants.find(
      item => Number(item.id || 0) === Number(config.shopifyVariantId)
    );

    if (!variant && variants.length === 1) {
      variant = variants[0];
    }
  } else {
    const sku = selectedProductSku();

    if (!sku) {
      state.shopifyVariantId = 0;
      if (productPrice) productPrice.textContent = '';
      setKeepsakeButtonState(false);
      return null;
    }

    variant = variants.find(
      item => String(item.sku || '').trim() === sku
    );
  }

  if (!variant) {
    throw new Error(
      'The selected ' +
      state.product.toLowerCase() +
      ' option is not available in Shopify.'
    );
  }

  if (variant.available === false) {
    throw new Error('That option is currently unavailable.');
  }

  state.shopifyVariantId = Number(variant.id || config.shopifyVariantId || 0);
  state.shopifyVariantSku = String(variant.sku || '');
  state.shopifyVariantTitle = String(variant.title || 'Default Title');
  state.shopifyPriceCents = Number(
    variant.price || config.defaultPriceCents || 0
  );

  if (productPrice) {
    productPrice.textContent = formatMoney(state.shopifyPriceCents);
  }

  setKeepsakeButtonState(false);
  return variant;
}

function wireKeepsakeTabs() {
  $$('#wl3ProductTabs button').forEach(button => {
    if (button.dataset.wlKeepsakeWired === 'true') return;
    button.dataset.wlKeepsakeWired = 'true';

    button.addEventListener('click', async () => {
      $$('#wl3ProductTabs button').forEach(item => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
      state.product = button.dataset.product;
      $('#wl3ProductName').textContent = state.product;
      resetCommerceSelection();
      renderProductOptions();

      try {
        await resolveSelectedShopifyVariant();
      } catch (error) {
        console.error('WagLife Shopify product selection failed:', error);
        showToast(
          error instanceof Error
            ? error.message
            : 'This product could not be loaded.',
          5200
        );
      }
    });
  });
}

ensureNewKeepsakeTabs();
wireKeepsakeTabs();

function setKeepsakeButtonState(isLoading, phase = '') {
  if (!keepsakeButton) return;

  const needsPhone = state.product === 'Phone Case' && !state.selectedPhoneModel;
  const config = WAGLIFE_PRODUCT_CATALOG[state.product];
  const awaitingPrintfulMap =
    config &&
    config.singleVariant &&
    config.fulfillmentReady === false;

  keepsakeButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  keepsakeButton.setAttribute('aria-disabled', needsPhone ? 'true' : 'false');
  keepsakeButton.style.pointerEvents = isLoading || needsPhone ? 'none' : '';
  keepsakeButton.classList.toggle('is-loading', isLoading);
  keepsakeButton.classList.toggle('is-disabled', needsPhone);

  if (isLoading && phase === 'cart') {
    keepsakeButton.textContent = 'Adding to Cart…';
  } else if (isLoading) {
    keepsakeButton.textContent = 'Creating Your ' + state.product + ' Preview…';
  } else if (needsPhone) {
    keepsakeButton.textContent = 'Choose Your Phone First';
  } else if (awaitingPrintfulMap) {
    keepsakeButton.textContent = 'Shopify Connected · Print Preview Next';
  } else {
    keepsakeButton.innerHTML = 'Preview & Add to Cart <span>→</span>';
  }
}

async function createPrintfulPreview() {
  const artworkUrl = state.printMasterUrls[state.selectedVariant] || '';
  const selectedVariant = await resolveSelectedShopifyVariant();

  if (!artworkUrl) {
    throw new Error('Choose a generated artwork version first.');
  }

  if (!/^https:\/\//i.test(artworkUrl)) {
    throw new Error('This artwork does not have a public print-ready URL yet.');
  }

  if (!selectedVariant) {
    throw new Error(state.product === 'Phone Case' ? 'Choose your phone model first.' : 'Choose a product option first.');
  }

  const requestedPrintfulVariantId = printfulVariantIdFromSku(selectedVariant.sku);
  if (!requestedPrintfulVariantId) {
    throw new Error('This Shopify option is missing its Printful variant connection.');
  }

  const response = await fetchWithTimeout(
    WAGLIFE_PRINTFUL_PREVIEW_ENDPOINT,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        artworkUrl,
        product: state.product,
        variantId: requestedPrintfulVariantId,
        orientation: state.orientation,
        printWidth: currentPrintMasterSpec().width,
        printHeight: currentPrintMasterSpec().height
      })
    },
    90000,
    'The keepsake preview took too long. Please try again.'
  );

  const responseText = await response.text();
  let data = null;

  try {
    data = JSON.parse(responseText);
  } catch (error) {
    throw new Error('WagLife received an unreadable response from the keepsake service.');
  }

  if (!response.ok || !data || !data.success) {
    throw new Error((data && data.error) || 'The keepsake preview could not be created.');
  }

  if (!data.mockupUrl) {
    throw new Error('Printful did not return a keepsake preview.');
  }

  state.printfulPreviewUrl = data.mockupUrl;
  state.printfulProductId = Number(data.productId || 0);
  state.printfulVariantId = Number(data.variantId || requestedPrintfulVariantId);
  state.printfulPlacement = String(data.placement || '');

  productImage.src = state.printfulPreviewUrl;
  $('#wl3ProductName').textContent = state.product;

  return data;
}

async function addSelectedKeepsakeToCart() {
  const variant = await resolveSelectedShopifyVariant();
  if (!variant || !state.shopifyVariantId) {
    throw new Error('Choose an available product option first.');
  }

  const artworkPreviewUrl = state.generatedUrls[state.selectedVariant] || '';
  const printMasterUrl = state.printMasterUrls[state.selectedVariant] || '';
  const displaySize = state.product === 'Framed Canvas'
    ? displayCanvasSize(state.selectedProductSize)
    : state.selectedPhoneModel;

  /*
    Customer-facing cart properties stay short and readable.

    Shopify themes conventionally hide line-item properties whose names begin
    with an underscore. WagLife still preserves every production value for
    order processing and Printful fulfillment without exposing signed artwork
    URLs, internal IDs, placement data, or generation metadata in the cart.
  */
  const properties = {
    '_waglife_artwork_preview_url': artworkPreviewUrl,
    '_waglife_print_master_url': printMasterUrl,
    '_waglife_mockup_url': state.printfulPreviewUrl,
    '_waglife_artwork_version': String(state.selectedVariant + 1),
    '_waglife_orientation': state.orientation,
    '_waglife_story': state.story,
    '_waglife_style': state.look,
    '_waglife_artistic_intensity': String(state.intensity) + '%',
    '_waglife_keepsake': state.product,
    '_waglife_selected_option': displaySize,
    '_printful_sku': state.shopifyVariantSku,
    '_printful_product_id': String(state.printfulProductId || ''),
    '_printful_variant_id': String(state.printfulVariantId || ''),
    '_printful_placement': state.printfulPlacement
  };

  if (state.product === 'Framed Canvas') {
    properties['Frame color'] = state.selectedProductColor;
    properties['Finished size'] = displaySize;
  }

  if (state.product === 'Phone Case') {
    properties['Phone model'] = state.selectedPhoneModel;
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: state.shopifyVariantId,
        quantity: 1,
        properties
      }]
    })
  });

  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.description || data?.message || 'WagLife could not add this keepsake to the cart.');
  }

  return data;
}

if (keepsakeButton) {
  keepsakeButton.removeAttribute('href');
  keepsakeButton.setAttribute('role', 'button');
  keepsakeButton.setAttribute('tabindex', '0');

  const openKeepsakePreview = async event => {
    event.preventDefault();

    if (keepsakeButton.getAttribute('aria-busy') === 'true') return;
    if (state.product === 'Phone Case' && !state.selectedPhoneModel) {
      showToast('Choose your iPhone model first.');
      return;
    }

    const selectedConfig = WAGLIFE_PRODUCT_CATALOG[state.product];
    if (selectedConfig && selectedConfig.singleVariant && selectedConfig.fulfillmentReady === false) {
      showToast(
        state.product +
        ' is synced in Shopify. Personalized Printful preview mapping is the final connection before ordering.',
        7000
      );
      return;
    }

    setKeepsakeButtonState(true, 'preview');
    showToast('Creating your real ' + state.product.toLowerCase() + ' preview…', 6000);

    try {
      await createPrintfulPreview();
      setKeepsakeButtonState(true, 'cart');
      await addSelectedKeepsakeToCart();
      showToast('Your ' + state.product.toLowerCase() + ' was added to the cart.', 4200);
      window.setTimeout(() => {
        window.location.assign('/cart');
      }, 650);
    } catch (error) {
      console.error('WagLife keepsake checkout failed:', error);
      showToast(
        error instanceof Error ? error.message : 'The keepsake could not be added.',
        7000
      );
      setKeepsakeButtonState(false);
    }
  };

  keepsakeButton.addEventListener('click', openKeepsakePreview);
  keepsakeButton.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') {
      openKeepsakePreview(event);
    }
  });
}


const commerceStyle = document.createElement('style');
commerceStyle.textContent = `
#wl-art-studio-v3 .wl3-product-preview #wl3ProductPrice { display:block; margin-top:4px; color:var(--gold); font-weight:800; }
#wl-art-studio-v3 .wl3-product-options { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px; margin-top:14px; }
#wl-art-studio-v3 .wl3-product-options label { display:grid; gap:6px; font-size:12px; font-weight:800; }
#wl-art-studio-v3 .wl3-product-options select { width:100%; min-height:46px; padding:0 12px; border-radius:12px; border:1px solid rgba(255,255,255,.16); background:rgba(255,255,255,.06); color:inherit; font:inherit; }
#wl-art-studio-v3 .wl3-product-options > small { grid-column:1/-1; opacity:.68; line-height:1.45; }
#wl-art-studio-v3 #wl3KeepsakeButton.is-disabled { opacity:.52; }
@media(max-width:560px){#wl-art-studio-v3 .wl3-product-options{grid-template-columns:1fr;}}
`;
document.head.appendChild(commerceStyle);

ensureNewKeepsakeTabs();
wireKeepsakeTabs();
renderProductOptions();
resolveSelectedShopifyVariant().catch(error => {
  console.error('WagLife initial product load failed:', error);
});

let saveTimeout = null;

function setSaveButtonState(isSaving) {
const label = isSaving ? 'Saving to Photos…' : 'Save Artwork';
saveButton.disabled = isSaving;
saveButton.setAttribute('aria-busy', isSaving ? 'true' : 'false');
saveButton.innerHTML = label + (isSaving ? '' : ' <span>↓</span>');
}

async function artworkUrlToDataUrl(url) {
if (String(url).startsWith('data:image/')) return url;

const response = await fetch(url);
if (!response.ok) throw new Error('The selected artwork could not be prepared for saving.');

const blob = await response.blob();

return await new Promise((resolve, reject) => {
const reader = new FileReader();
reader.onload = () => resolve(String(reader.result || ''));
reader.onerror = () => reject(new Error('The selected artwork could not be prepared for saving.'));
reader.readAsDataURL(blob);
});
}

async function browserSaveFallback(url) {
const response = await fetch(url);
const blob = await response.blob();
const downloadUrl = URL.createObjectURL(blob);
const link = document.createElement('a');
link.href = downloadUrl;
link.download = 'waglife-' + state.orientation + '-' + state.storyKey + '-' + state.lookKey + '.jpg';
document.body.appendChild(link);
link.click();
link.remove();
window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
showToast('Artwork downloaded.');
}


async function handlePlusEntitlementChanged(active) {
  const isActive = active === true;

  wagLifePlusActive = isActive;
  window.WAGLIFE_PLUS_ACTIVE = isActive;
  sessionStorage.setItem(PLUS_ACTIVE_KEY, isActive ? 'true' : 'false');

  if (!isActive) return;

  clearCreationLimitState();
  removeCreationLimitUpgrade();
  removeGenerationRetryButton();

  /*
    Native iOS intentionally delivers the entitlement in two ways:
    1. waglife:plus-entitlement-changed
    2. WagLifeArtStudio.subscriptionUnlocked()

    Those can arrive back-to-back. The first callback starts generation and
    immediately sets generationInFlight. The second callback must therefore
    be treated as a harmless duplicate. Previously it fell through and moved
    the customer from Step 4 back to Step 3 while generation was running.
  */
  if (state.generationInFlight) {
    return;
  }

  if (
    state.resumeGenerationAfterPurchase &&
    state.file
  ) {
    state.resumeGenerationAfterPurchase = false;
    showToast('WagLife Plus unlocked. Creating your artwork…', 4200);
    setStep(4);
    await runGeneration();
    return;
  }

  state.resumeGenerationAfterPurchase = false;
  showToast('WagLife Plus unlocked.', 3200);

  /*
    Never move a paid customer backward during an active or newly resumed
    generation. Step 3 is only a safe fallback when no generation is running.
  */
  if (state.step === 4 && !state.generationInFlight) {
    setStep(3);
  }
}

window.addEventListener(
  'waglife:plus-entitlement-changed',
  event => {
    const active =
      event &&
      event.detail &&
      event.detail.active === true;

    handlePlusEntitlementChanged(active);
  }
);

window.WagLifeArtStudio = window.WagLifeArtStudio || {};
window.WagLifeArtStudio.subscriptionUnlocked = () => {
  handlePlusEntitlementChanged(true);
};

window.WagLifeArtStudio.getPrintStatus = () => ({
  orientation: state.orientation,
  required: currentPrintMasterSpec(),
  selectedVariant: state.selectedVariant,
  previewUrl: state.generatedUrls[state.selectedVariant] || '',
  printMasterUrl: state.printMasterUrls[state.selectedVariant] || '',
  dimensions: state.artworkDimensions[state.selectedVariant] || null
});
window.WagLifeArtStudio.founderTestMode = WAGLIFE_FOUNDER_TEST_MODE;
window.WagLifeArtStudio.disableFounderTestMode = () => {
  sessionStorage.removeItem('waglife-founder-test-mode');
};

window.WagLifeArtStudio.saveArtworkResult = result => {
window.clearTimeout(saveTimeout);
setSaveButtonState(false);

if (result && result.success) {
showToast(result.message || 'Saved to Photos.');
return;
}

showToast(result && result.message ? result.message : 'WagLife could not save this artwork to Photos.', 5200);
};

saveButton.addEventListener('click', async () => {
const url = state.printMasterUrls[state.selectedVariant] || state.generatedUrls[state.selectedVariant] || state.imageUrl;
if (!url || saveButton.disabled) return;

setSaveButtonState(true);
showToast('Saving to your Photos library…');

try {
const imageData = await artworkUrlToDataUrl(url);
const nativeSaveHandler = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.saveArtwork;

if (nativeSaveHandler) {
nativeSaveHandler.postMessage({
imageData,
fileName: 'waglife-' + state.orientation + '-' + state.storyKey + '-' + state.lookKey + '.jpg'
});

saveTimeout = window.setTimeout(() => {
setSaveButtonState(false);
showToast('Saving took too long. Please try again.');
}, 30000);

return;
}

await browserSaveFallback(url);
setSaveButtonState(false);
} catch (error) {
console.error('WagLife save failed:', error);
setSaveButtonState(false);
showToast(error instanceof Error ? error.message : 'The artwork could not be saved.', 5200);
}
});

$('#wl3ShareButton').addEventListener('click', async () => {
const url = state.generatedUrls[state.selectedVariant] || state.imageUrl;

try {
const response = await fetch(url);
const blob = await response.blob();
const extension = (blob.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg');
const file = new File([blob], 'waglife-artwork.' + extension, { type: blob.type || 'image/jpeg' });
const shareData = {
title: 'My WagLife Artwork',
text: 'Look at the memory I created in WagLife AI Art Studio.',
files: [file]
};

if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
await navigator.share(shareData);
} else {
showToast('Save the artwork, then share it from your device.');
}
} catch (error) {
if (error.name !== 'AbortError') showToast('Share is not available right now.');
}
});

$('#wl3ExploreAnother').addEventListener('click', () => {
state.refine = '';
setStep(2);
});

root.addEventListener('click', function (event) {
  const target = event.target.closest('button, a');
  if (!target) return;

  if (target === keepsakeButton || target.closest('#wl3KeepsakeButton')) {
    waglifeTrack('keepsake_viewed', {
      product: state.product,
      selectedVariant: state.selectedVariant
    });
  }

  const targetText = String(target.textContent || '').toLowerCase();
  if (targetText.indexOf('add to cart') >= 0 || targetText.indexOf('order') >= 0) {
    waglifeTrack('commerce_intent', {
      product: state.product,
      priceCents: state.shopifyPriceCents || 0
    });
  }
});


})();